import {Layout} from '~/components'
import _ from 'lodash'
import {GraphAggregateCard} from './graph_aggregate_card'
import {useQueryParams, useSetQueryParams} from '@eitje/bridge'
import {useEffect} from 'react'
import {requireProps} from '~/helpers'
import {exists} from '@eitje/utils'

export const GraphAggregates = ({metrics, aggregates, loading = false, layoutProps}) => {
	requireProps('GraphAggregates', {metrics, aggregates})

	const {graph_name} = useQueryParams()
	const setQueryParams = useSetQueryParams()

	useEffect(() => {
		if (!_.find(aggregates, {name: graph_name})) {
			const defaultGraph = _.first(aggregates)?.name
			setQueryParams({graph_name: defaultGraph})
		}
	}, [graph_name, aggregates])

	return (
		<Layout gap={8} {...layoutProps}>
			{aggregates.map(({name: metricName, docsId, infoIconMessage, aggregateFn, formatFn, delta}) => {
				const computedValue = computeAggregateLabel({metricName, aggregateFn, formatFn, metrics, loading})

				return (
					<GraphAggregateCard
						key={metricName}
						name={metricName}
						docsId={docsId}
						infoIconMessage={infoIconMessage}
						value={computedValue}
						delta={delta}
					/>
				)
			})}
		</Layout>
	)
}

const computeAggregateLabel = ({metricName, aggregateFn, formatFn, metrics, loading}) => {
	if (loading) return '...'
	const seriesPoints = _.find(metrics, {name: metricName})?.data
	const seriesValues = _.map(seriesPoints, 'y')
	if (!seriesValues.some(exists)) return '-'
	const aggregate = aggregateFn ? aggregateFn(seriesValues) : seriesValues
	return formatFn ? formatFn(aggregate) : aggregate
}
